import { OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { ViewTemplateForClient } from '@frontend/vanilla/core';
import { BetstationDialog } from '@frontend/vanilla/shared/betstation-dialog';
import { DialogType } from '@frontend/vanilla/shared/dialog';

import { LoyaltyLoginConfig } from './loyalty-login.client-config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, OverlayModule, BetstationDialog],
    selector: 'vn-loyalty-login-overlay',
    templateUrl: './loyalty-login-overlay.html',
})
export class LoyaltyLoginOverlayComponent {
    private readonly overlayRef = inject(OverlayRef);
    private readonly loyaltyLoginConfig = inject(LoyaltyLoginConfig);

    readonly DialogType = DialogType;
    readonly errorCode = input.required<string>();
    readonly overlay = computed<ViewTemplateForClient | undefined>(
        () =>
            this.loyaltyLoginConfig.overlays.find(
                (overlay: ViewTemplateForClient) => overlay.validation?.['errorCode']?.toUpperCase() === this.errorCode().toUpperCase(),
            ) ??
            this.loyaltyLoginConfig.overlays.find(
                (overlay: ViewTemplateForClient) => overlay.validation?.['errorCode']?.toUpperCase() === 'GENERAL_ERROR',
            ),
    );

    getDialogClass(): string {
        const type = this.overlay()?.validation?.['type']?.toLowerCase();
        switch (type) {
            case DialogType.Error:
                return 'generic-container-wrapper--error';
            case DialogType.Success:
                return 'generic-container-wrapper--success';
            case DialogType.Info:
            default:
                return 'generic-container-wrapper--neutral';
        }
    }

    close() {
        this.overlayRef.detach();
    }
}
